<div class="phone-row">
  <mat-form-field class="country-code-field" appearance="outline">
    <mat-label>Code</mat-label>
    <mat-select
      [formControl]="countryControl"
      panelClass="country-select-panel"
      disableOptionCentering
    >
      <mat-select-trigger>
        <span class="flag">{{ selectedCountry?.flag }}</span> +{{ selectedCountry?.callingCode }}
      </mat-select-trigger>
      <ngx-mat-select-search
        [formControl]="countrySearchControl"
        placeholderLabel="Search country..."
        noEntriesFoundLabel="No countries found"
      ></ngx-mat-select-search>
      @for (country of filteredCountries; track country.code) {
      <mat-option [value]="country.code">
        {{ country.flag }} {{ country.name }} (+{{ country.callingCode }})
      </mat-option>
      }
    </mat-select>
  </mat-form-field>

  <mat-form-field class="phone-number-field" appearance="outline">
    @if (label) {
      <mat-label>{{ label }}</mat-label>
    }
    <input
      matInput
      type="tel"
      [formControl]="internalControl"
      [errorStateMatcher]="errorMatcher"
      (blur)="onBlur()"
    />
    <mat-error>
      @if (internalControl?.hasError('required')) {
        This field is required
      } @else if (internalControl?.hasError('invalidPhone')) {
        Please enter a valid phone number
      }
    </mat-error>
  </mat-form-field>
</div>
